export const ArrowIcon01 = () => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='6' height='11' viewBox='0 0 6 11' fill='none'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M0.891814 0.52638C1.15338 0.322938 1.53035 0.370058 1.73379 0.631627L5.23379 5.13163C5.40231 5.34829 5.40231 5.65169 5.23379 5.86836L1.73379 10.3684C1.53035 10.6299 1.15338 10.677 0.891814 10.4736C0.630245 10.2702 0.583125 9.8932 0.786567 9.63163L4.00006 5.49999L0.786567 1.36836C0.583125 1.10679 0.630245 0.729822 0.891814 0.52638Z'
        fill='none'
      />
    </svg>
  );
};

export const ArrowIcon02 = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='24' height='25' viewBox='0 0 24 25' fill='none'>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M9.23964 7.73123C9.55916 7.42292 10.0772 7.42292 10.3967 7.73123L14.7604 11.9418C15.0799 12.2501 15.0799 12.7499 14.7604 13.0582L10.3967 17.2688C10.0772 17.5771 9.55916 17.5771 9.23964 17.2688C8.92012 16.9605 8.92012 16.4606 9.23964 16.1523L13.0247 12.5L9.23964 8.84772C8.92012 8.53941 8.92012 8.03954 9.23964 7.73123Z'
      fill='#9198A3'
    />
  </svg>
);

export const ArrowIcon03 = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 20 20' fill='none'>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M6.85982 16.7682C6.43554 16.4146 6.37821 15.7841 6.73178 15.3598L11.1983 9.99997L6.73178 4.64016C6.37821 4.21588 6.43554 3.58532 6.85981 3.23175C7.28409 2.87819 7.91466 2.93551 8.26822 3.35979L13.2682 9.35979C13.5773 9.73064 13.5773 10.2693 13.2682 10.6402L8.26822 16.6402C7.91466 17.0644 7.28409 17.1218 6.85982 16.7682Z'
      fill='#7E848C'
    />
  </svg>
);

export const ArrowBackIcon = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 20 20' fill='none'>
    <path
      d='M8.89189 3L2 10M2 10L8.89189 17M2 10H19'
      stroke='#24272C'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);

//케어노트
//상승 삼각형 SVG 아이콘 (React 컴포넌트)
export const CareUpIcon = ({ size = 8, color = '#FB3F62' }) => (
  <svg xmlns='http://www.w3.org/2000/svg' width={size} height={(size * 6) / 8} viewBox='0 0 8 6' fill='none'>
    <path
      d='M3.44807 0.207305C3.64764 -0.0692244 4.05939 -0.0692243 4.25896 0.207305L7.61163 4.8529C7.85028 5.18359 7.61399 5.64767 7.20485 5.64767H0.50218C0.0930424 5.64767 -0.143246 5.18359 0.0954022 4.8529L3.44807 0.207305Z'
      fill={color}
    />
  </svg>
);
//하강 삼각형 SVG 아이콘 (React 컴포넌트)
export const CareDownIcon = ({ size = 8, color = '#006eee' }) => (
  <svg xmlns='http://www.w3.org/2000/svg' width={size} height={(size * 6) / 8} viewBox='0 0 8 6' fill='none'>
    <path
      d='M3.44807 5.4382C3.64764 5.71473 4.05939 5.71473 4.25896 5.4382L7.61163 0.792603C7.85028 0.461921 7.61399 0 7.20619 0H0.500843C0.0930387 0 -0.143249 0.461921 0.0954002 0.792603L3.44807 5.4382Z'
      fill={color}
    />
  </svg>
);
// 기간 선택 화살표 아이콘
export const PeriodArrowIcon = ({
  size = 16,
  color = '#24272C',
  direction = 'down', // 'down' | 'up'
}) => {
  const rotate = direction === 'up' ? 'rotate(180 8 8)' : undefined;

  return (
    <svg xmlns='http://www.w3.org/2000/svg' width={size} height={size} viewBox='0 0 16 16' fill='none'>
      <g transform={rotate}>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M2.58583 5.48766C2.86868 5.14824 3.37314 5.10238 3.71256 5.38523L8.00041 8.95844L12.2883 5.38523C12.6277 5.10238 13.1321 5.14824 13.415 5.48766C13.6978 5.82708 13.652 6.33153 13.3126 6.61438L8.51256 10.6144C8.21588 10.8616 7.78494 10.8616 7.48826 10.6144L2.68826 6.61438C2.34884 6.33153 2.30298 5.82708 2.58583 5.48766Z'
          fill={color}
        />
      </g>
    </svg>
  );
};

//검사리스트 카드 더보기버튼
// export const ArrowIcon03 = () => (
//   <svg xmlns='http://www.w3.org/2000/svg' width='6' height='10' viewBox='0 0 6 10' fill='none'>
//     <path
//       fill-rule='evenodd'
//       clip-rule='evenodd'
//       d='M0.23964 0.231232C0.55916 -0.0770772 1.0772 -0.0770772 1.39672 0.231232L5.76036 4.44176C6.07988 4.75007 6.07988 5.24993 5.76036 5.55824L1.39672 9.76877C1.0772 10.0771 0.55916 10.0771 0.23964 9.76877C-0.07988 9.46046 -0.07988 8.96059 0.23964 8.65228L4.02473 5L0.23964 1.34772C-0.07988 1.03941 -0.07988 0.53954 0.23964 0.231232Z'
//       fill='#9198A3'
//     />
//   </svg>
// );
